/**
 * Parses a number to a string with thousands separator.
 * @param {number} value The number to parse.
 * @param {number} fractionDigits The number of decimal places to display. Default is 0.
 * @returns {string} The parsed string representation of the number with thousands separator.
 */
export const parseToThousands = (value = 0, fractionDigits = 0) =>
  Math.abs(value).toLocaleString(undefined, {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits,
  });
